export default __webpack_public_path__ + "static/media/portuguese.2d630d00.svg";